import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { SuggestBox } from '@mummssoftware/common-ui';
import { emptyOption } from '@mummssoftware/utils/constants';
import { useStyles } from './style';
import { VisitContext } from '../Context/contexts/VisitContext';
import { Context } from '../../context';
import { SET_VISIT_EPISODE } from '../Context/constants';
import defaults from '../../translations/en.json';

const EpisodeDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
const EpisodeInfoDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
type EpisodeCheckProps = {
  episodes: mumms.episode[] | undefined;
};
export const EpisodeCheck = ({ episodes }: EpisodeCheckProps) => {
  const { visitEpisode, dispatchVisit } = useContext(VisitContext);
  const { currentUser } = useContext(Context);

  const siteTimezone = currentUser.siteTimezone || moment.tz.guess();

  const classes = useStyles();

  const episodeOptions =
    episodes && episodes.length
      ? episodes
          .map((x: mumms.episode) => {
            const lastEpisode = episodes[episodes.length - 1];
            return {
              ...x,
              label: `E ${x.episodeNumber + 1}`,
              value: `E ${x.episodeNumber + 1}`,
              isLast: x.referralId === lastEpisode.referralId,
            };
          })
          .sort((a, b) => (a.episodeNumber > b.episodeNumber ? -1 : 1))
      : [];
  useEffect(() => {
    dispatchVisit({
      type: SET_VISIT_EPISODE,
      payload: episodeOptions[0],
    });
  }, []);

  const onEpisodeChange = (newEpisode: any) =>
    dispatchVisit({
      type: SET_VISIT_EPISODE,
      payload: newEpisode,
    });
  const referralDate =
    visitEpisode && moment.tz(visitEpisode.utcReferralDate, siteTimezone);
  const referralText = referralDate
    ? `${defaults.referralDate}: ${referralDate.format('MM/DD/YY')}`
    : '';
  const dischargeDate =
    visitEpisode &&
    visitEpisode.utcDischargeDate &&
    moment.tz(visitEpisode.utcDischargeDate, siteTimezone);
  const dischargeText = dischargeDate
    ? ` - ${defaults.dischargeDate}: ${dischargeDate.format('MM/DD/YY')}`
    : '';
  const episodeText = `${referralText}${dischargeText}`;
  return (
    <EpisodeDiv id="episode">
      <SuggestBox
        fitcontent
        options={episodeOptions}
        value={visitEpisode || emptyOption}
        onChange={onEpisodeChange}
        className={classes.episodePicker}
      />
      <EpisodeInfoDiv>{episodeText}</EpisodeInfoDiv>
    </EpisodeDiv>
  );
};
